import {SettingsApiDto} from "./_RestModels";

export default class Settings {
    constructor(public readonly googleClientId: string){}

    public static fromJson(json: SettingsApiDto): Settings {
        return  new Settings(json.googleClientId)
    }
}